import { gql } from '../../../__generated__/graphql/catalog'

export const FETCH_BULK_LAYOUT = gql(`
  query FetchBulkLayout($handle: String!) {
    collectionView(handle: $handle) {
      title
      socialDescription
      socialImage
      noindex
      sections {
        __typename
        ... on CollectionViewHeroSection {
          id
          title
          subtitle
          imagePlacement
          imageDesktop
          imageMobile
          name
        }
        ... on CollectionGridSection {
          visualFiltersSectionV2 {
            tiles {
              id
              ctaText
              filter
              value
            }
          }
        }
      }
    }
  }
`)
